<section
    class="bg-landing relative flex h-[35vh] items-center bg-cover bg-center bg-no-repeat dark:bg-none md:h-[45vh] md:max-h-[40rem] md:min-h-[30rem]"
    *ngIf="env.HOME?.SECTIONS?.includes('LANDER')">
    <div class="max-content z-[1] w-full">
        <h1
            class="py-8 text-3xl font-bold text-white md:w-9/12 md:text-6xl md:leading-[4.75rem] lg:w-1/2"
            id="main-content">
            {{ 'LANDING_HERO_TITLE' | translate }}
        </h1>
    </div>
    <span
        class="max-content absolute -bottom-32 right-7 top-20 flex md:-bottom-12 md:-top-24 md:left-0 md:right-0 md:flex md:justify-end"
        *ngIf="env.THEME_NAME === themeFeature.PILET">
        <img class="h-full dark:filter-yellow" alt="" src="{{ assetsPath$ | async }}/img/ridango-logo-shape.svg" />
    </span>
</section>

<section class="overflow-hidden" *ngIf="env.HOME?.SECTIONS?.includes('ACTIONS')">
    <div class="max-content dark:bg-contrast-black lg:grid lg:grid-cols-[1fr_1.5fr]">
        <article
            class="relative pb-10 pt-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-primary before:content-[''] dark:before:bg-contrast-black lg:pr-10 lg:pt-10 lg:before:right-0">
            <div class="hero-left-section">
                <div innerHtml="{{ 'LANDING_HERO_LEFT_SECTION' | translate }}"></div>
                <a
                    class="btn-primary tartu-light:bg-[#F7F2E9] tartu-light-dark:!text-black tallinn-light-dark:bg-secondary-button jk-light:bg-grey-smoke tartu-light-dark:px-4 tartu-light-dark:py-2 tartu-light-dark:rounded-lg tartu-light:shadow-md dark:bg-contrast-yellow"
                    *ngIf="!ridangoAuth.getLoginStatus() && env.THEME_NAME !== themeFeature.PILET"
                    [routerLink]="['/login' | localize]">
                    {{ 'LOG_INTO_TITLE' | translate }}
                </a>
                <a
                    class="btn-primary"
                    *ngIf="env.THEME_NAME === themeFeature.PILET"
                    [routerLink]="['purchase/ticket' | localize]">
                    {{ 'BTN_BUY_TICKET' | translate }}
                </a>
            </div>
        </article>

        <section
            class="relative py-10 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-gradient-to-b before:from-[#F0F6F8] before:to-[#EBEFF0] before:content-[''] dark:before:from-contrast-black dark:before:to-contrast-black lg:pl-10 lg:before:left-0"
            *ngIf="env.APP_NAME === 'panevezys-corp'">
            <div class="mb-2 flex items-center justify-between">
                <h2 class="text-2xl font-bold md:text-3xl">
                    {{ 'BUSINESS_CUSTOMER_ACCOUNT_FEATURES_TITLE' | translate }}
                </h2>
            </div>
            <ul class="list-disc pl-6" [innerHtml]="'ACCOUNT_FEATURES_LINE' | translate"></ul>
        </section>

        <section
            class="relative py-10 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-gradient-to-b before:from-[#F0F6F8] before:to-[#EBEFF0] before:content-[''] dark:before:from-contrast-black dark:before:to-contrast-black lg:pl-10 lg:before:left-0"
            *ngIf="env.APP_NAME !== 'panevezys-corp'">
            <div class="mb-2 flex items-center justify-between">
                <h2 class="text-2xl font-bold md:text-3xl">
                    {{ 'LANDING_HERO_TRAVELCARDS_TITLE' | translate }}
                </h2>
                <img
                    class="h-7 dark:filter-yellow"
                    *ngIf="env.HOME?.SHOW_TRAVEL_CARD_LOGO"
                    alt=""
                    src="{{ assetsPath$ | async }}/img/uhiskaart.svg" />
            </div>

            <p
                class="mb-2"
                innerHtml="{{ 'LANDING_HERO_TRAVELCARDS_TOP_DESCRIPTION' | translate }}"
                ridangoTranslatedLink></p>

            <ul class="travelcard-logos mb-2 grid grid-cols-2 md:grid-cols-4" *ngIf="env.LANDING_TRAVELCARD_LINKS">
                <li *ngFor="let item of getAllowedLinks(env.LANDING_TRAVELCARD_LINKS)">
                    <a
                        class="flex flex-col items-center px-4 py-5 text-center"
                        href="{{ item.link | localize }}"
                        ridangoTranslatedLink>
                        <img
                            class="{{ item.class }}"
                            class="mb-2 h-6 object-contain dark:filter-yellow"
                            alt=""
                            src="{{ assetsPath$ | async }}{{ item.icon }}" />
                        {{ item.tag | translate }}
                    </a>
                </li>
            </ul>

            <p innerHtml="{{ 'LANDING_HERO_TRAVELCARDS_BOTTOM_DESCRIPTION' | translate }}" ridangoTranslatedLink></p>
        </section>
    </div>
</section>

<section class="bg-white pb-5 pt-10 lg:pb-7 lg:pt-14" *ngIf="env.HOME?.SECTIONS?.includes('CAROUSEL')">
    <article class="max-content">
        <h2 class="sr-only">{{ 'LANDING_COUNTY_TITLE' | translate }}</h2>

        <p class="lg:text-center">
            {{ 'LANDING_COUNTY_DESCRIPTION' | translate }}
        </p>

        <swiper class="county-slider mt-5 pb-10 lg:mt-10" [config]="countySliderConf">
            <ng-template *ngFor="let item of env.COUNTY_SLIDER" swiperSlide>
                <a
                    class="group flex flex-col items-center px-4 hover:no-underline dark:bg-contrast-yellow"
                    href="{{ item.link }}"
                    target="_blank"
                    rel="noopener">
                    <img
                        class="h-6 w-full object-contain"
                        *ngIf="item.logo"
                        alt="{{ 'LOGO_ARIA_LABEL' | translate }}"
                        src="{{ assetsPath$ | async }}{{ item.logo }}" />
                    <mat-icon class="text-gray-700" *ngIf="!item.logo">location_city</mat-icon>
                    <span class="mt-1 text-secondary group-hover:underline dark:text-contrast-black">{{
                        item.name
                    }}</span>
                </a>
            </ng-template>
        </swiper>
    </article>
</section>

<section class="bg-primary py-10 dark:bg-contrast-black lg:py-14" *ngIf="env.HOME?.SECTIONS?.includes('BENEFITS')">
    <article class="max-content">
        <h2 class="text-2xl font-bold text-white md:text-3xl lg:text-center">
            {{ 'LANDING_LIST_TITLE' | translate }}
        </h2>

        <ul
            class="landing-list-items mt-7 grid gap-7 lg:mt-10 lg:grid-cols-4 lg:gap-10"
            innerHtml="{{ 'LANDING_LIST_ITEMS' | translate }}"></ul>

        <div class="mt-7 flex items-center justify-center gap-5 lg:mt-10" *ngIf="!ridangoAuth.getLoginStatus()">
            <a class="btn-primary btn-primary--outlined text-center" href="{{ '/login' | localize }}">
                {{ 'BTN_LOG_IN' | translate }}
            </a>
            <p class="text-white">{{ 'VERTICAL_SEPARATOR_OR' | translate }}</p>
            <a class="btn-primary btn-primary--outlined text-center" href="{{ '/register' | localize }}">
                {{ 'BTN_REGISTER' | translate }}
            </a>
        </div>
    </article>
</section>

<section class="overflow-hidden bg-white py-10" *ngIf="env.HOME?.SECTIONS?.includes('NOTICES')">
    <article class="max-content">
        <header class="flex items-center justify-between">
            <h2 class="text-2xl font-bold md:text-3xl">{{ 'LANDING_NOTICES_TITLE' | translate }}</h2>

            <span *ngIf="env.NOTICE_SLIDES >= 4">
                <ul class="hidden gap-7 md:flex">
                    <li>
                        <button
                            class="swiper-navigation-button--prev h-5 w-5 rotate-45 rounded-sm border-b-2 border-l-2 border-solid border-secondary p-0 transition-opacity dark:border-contrast-yellow"
                            attr.aria-label="{{ 'PREVIOUS_SLIDE_ARIA_LABEL' | translate }}"></button>
                    </li>

                    <li>
                        <button
                            class="swiper-navigation-button--next mr-4 h-5 w-5 rotate-45 rounded-sm border-r-2 border-t-2 border-solid border-secondary p-0 transition-opacity dark:border-contrast-yellow"
                            attr.aria-label="{{ 'NEXT_SLIDE_ARIA_LABEL' | translate }}"></button>
                    </li>
                </ul>
            </span>
        </header>

        <swiper class="notices-slider mt-3 pb-10 md:pb-0 lg:mt-7" [config]="noticesSliderConf">
            <ng-template *ngFor="let item of [].constructor(env.NOTICE_SLIDES); let i = index" swiperSlide>
                <article
                    class="notices-slider__slide"
                    innerHtml="{{ 'NOTICES_SLIDE_' + i | translate }}"
                    ridangoTranslatedLink></article>
            </ng-template>
        </swiper>
    </article>
</section>
